import { Box } from '@mui/material';

export type HighlightSegment = { text: string; match: boolean };

/**
 * Split text into matched and unmatched runs, so the hit can be highlighted.
 *
 * Returns a single unmatched run when there is nothing to highlight, so callers
 * need no special case.
 */
export const highlightSegments = (text: string, query: string): HighlightSegment[] => {
  const needle = query.trim().toLowerCase();
  if (!needle || !text) return [{ text, match: false }];

  const segments: HighlightSegment[] = [];
  const haystack = text.toLowerCase();
  let cursor = 0;
  let found = haystack.indexOf(needle);

  while (found !== -1) {
    if (found > cursor) segments.push({ text: text.slice(cursor, found), match: false });
    // Sliced from the ORIGINAL text, not the lowercased copy, so "Waved" stays
    // capitalised when the query was "waved".
    segments.push({ text: text.slice(found, found + needle.length), match: true });
    cursor = found + needle.length;
    found = haystack.indexOf(needle, cursor);
  }

  if (cursor < text.length) segments.push({ text: text.slice(cursor), match: false });
  return segments;
};

export const HighlightedText = ({ text, query }: { text: string; query: string }) => (
  <>
    {highlightSegments(text, query).map((segment, index) =>
      segment.match ? (
        <Box
          key={index}
          component="mark"
          sx={{ bgcolor: 'warning.light', color: 'inherit', px: 0.2, borderRadius: 0.5 }}
        >
          {segment.text}
        </Box>
      ) : (
        <Box component="span" key={index}>
          {segment.text}
        </Box>
      )
    )}
  </>
);
